import { render } from "./TRInput.vue?vue&type=template&id=274d1e41&scoped=true"
import script from "./TRInput.vue?vue&type=script&lang=js"
export * from "./TRInput.vue?vue&type=script&lang=js"

import "./TRInput.vue?vue&type=style&index=0&id=274d1e41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274d1e41"]])

export default __exports__